export const commissionOptions = (_t: any) => [
  _t("revshare_1"),
  _t("revshare_2"),
  _t("revshare_3"),
  _t("revshare_4"),
];
